// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3MuX4","label":"Category_label__qBqNM","content":"Category_content__2dZ-5","header":"Category_header__2p2yA","location":"Category_location__3OK4W"};